<template>
    <v-app id="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
              <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">团员列表
                <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span>
              </span>
            </v-toolbar-title>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:0.8rem;">
              <div v-if="loading" style="margin-top:10rem;">
                <LoadingText />
              </div>
              <div v-else>
                <v-list subheader v-if="otherList.length > 0">
                  <v-list-item v-for="item in otherList" :key="item.GZ_COMPANY_STAFF_ID">
                      <v-list-item-avatar style="border-radius:0.3rem;">
                        <v-img v-if="item.STAFF_HEAD_URL!==''" :src="item.STAFF_HEAD_URL"></v-img>
                        <v-icon  v-else style="font-size:2.75rem;color:#9E9E9E;">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div v-if="item.STAFF_NAME!==''">{{item.STAFF_NAME}}</div>
                          <div v-else>{{item.STAFF_ALIAS}}</div>
                          <div style="font-size:0.7rem;padding-top:0.2rem;color:#9e9e9e;">加入时间：{{$moment(item.JOIN_DATE).format('YYYY-MM-DD HH:mm')}}</div>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <v-btn class="mx-2" dark small color="#F56C6C">
                            <v-icon color="#fff" style="font-size:1rem;margin-bottom:0.1rem;" @click="removeStaff(item)">fa fa-times</v-icon>
                        </v-btn>
                      </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <div v-else style="text-align:center;color:#9e9e9e;font-size:0.8rem;margin-top:10rem;">
                    暂无团员
                </div>
                <!-- <v-dialog v-model="promptVis" max-width="290">
                  <v-card>
                    <v-card-title style="font-size:1.1rem !important;">提示</v-card-title>
                    <v-card-text>确定移除?</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="promptVis = false">取消</v-btn>
                    <v-btn color="green darken-1" text @click="removeStaff">确定</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog> -->
              </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      adminList: [],
      otherList: [],
      shareVis: false,
      // 分享有效期(分钟)
      shareExpiry: 10,
      showCommon: false,
      companyCode: '',
      companyInfo: {},
      promptVis: false,
      curStaff: {},
      loading: true
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    var staffInfo = that.$AppHelper.getCustomData('staff_info');
    that.companyCode = staffInfo.COMPANY_CODE;
    if (staffInfo && staffInfo.STAFF_ROLE === 'admin') {
      that.showCommon = true
    }
    var code = that.$route.query.code
    if (code) {
      that.companyCode = code
      that.showCommon = true
    }
    that.getCompanyInfo()
    that.getStaffList()
  },
  created() {
  },
  methods: {
    goBack() {
      var that = this;
      that.$router.goBack()
    },
    // 获取员工列表
    getStaffList() {
      var that = this;
      if (!that.companyCode) {
        return
      }
      that.$api.bz.getStaffList({ code: that.companyCode }).then(res => {
        // console.log('getStaffList.res', res);
        if (!res.success) {
          // that.$toast.warning('获取员工列表失败');
          console.log('获取成员列表失败', res);
          return
        }
        that.list = res.data
        that.adminList = []
        that.otherList = []
        for (let index = 0; index < that.list.length; index++) {
          var item = that.list[index];
          if (item.STAFF_ROLE === 'admin') {
            that.adminList.push(item)
            continue;
          }
          that.otherList.push(item)
        }
        that.loading = false
      })
    },
    // 获取团队信息
    getCompanyInfo() {
      var that = this
      if (!that.companyCode) {
        return;
      }
      that.$api.bz.getCompanyInfo({ code: that.companyCode }).then(res => {
        if (!res.success) {
          // that.$toast.warning('获取团队信息失败');
          console.log('获取团队信息失败', res)
          return
        }
        that.companyInfo = res.data
      })
    },
    // 移除成员
    removeStaff(item) {
      var that = this
      that.$confirm('确定移除？', '提示').then(function() {
        that.$api.bz.removeStaff({ code: that.companyCode, staff_code: item.STAFF_CODE }).then(res => {
          if (!res.success) {
            console.log('移除成员失败', res)
            return
          }
          that.getStaffList();
          that.$toast.success('移除成功');
        })
      }, function() {})
    }

  }
}
</script>

<style scoped>
</style>
